import * as Selectors from './selectors';
import { filemanagerSlice } from './slice';

export * from './state';
export * from './file';
export * from './selectors';

const Reducer = filemanagerSlice.reducer;

export { Reducer, Selectors };
